module.exports = __webpack_public_path__ + "static/media/bar.ee3562a1.svg";